
export default {
  props: {
    closeTooltip: { type: [String, Object], default: null },
    size: {
      type: String,
      default: 'normal',
    },
  },
}
